import { render, staticRenderFns } from "./configManage.vue?vue&type=template&id=6d5ee47a&"
import script from "./configManage.vue?vue&type=script&lang=js&"
export * from "./configManage.vue?vue&type=script&lang=js&"
import style0 from "./configManage.vue?vue&type=style&index=0&id=6d5ee47a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports